import React, { useState, useEffect, useMemo } from 'react'
import Dropdown from 'src/component/custom/Dropdown';
import { useObjCommonFilterStore } from 'src/hooks/objCommonFilter';
import ObjCommonFilterSelection from 'src/component/custom/ObjCommonFilterSelection';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';
import useReduxState from 'src/hooks/useReduxState';

const OrderHistorySearchFilter = () => {
    const initialValues = {
        searchType: '',
        searchKeyword: '',
        searchArrayData: ''
    }
    const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();
    const [searchData, setSearchData] = useState({});
    const [searchValues, setSearchValues] = useState(initialValues);
    const [validationError, setValidationError] = useState({ searchError: '', searchByError: '' })

    const [continuationToken, setContinuationToken] = useReduxState('', 'setContinuationToken');
    const searchByDropdown = [
        { key: 'orderNumber', slug: 'Order Number' },
        { key: 'poNumber', slug: 'PO Number' },
        { key: 'invoiceNo', slug: 'Invoice Number' },
        { key: 'trackingNo', slug: 'Tracking/WayBill' },
        { key: 'releaseNo', slug: 'Release Number' },
        { key: 'orderType', slug: 'Order Type' },
    ]
    const { storageName: { ORDER_PAGE_TOKEN } } = System

    const searchOptionModified = useMemo(() => {
        const modifiedOption = {};
        searchByDropdown.forEach(v => {
            modifiedOption[v.key] = v.slug;
        });
        return modifiedOption;
    })

    const orderTypeList = [
        { key: 'Online', slug: 'Online' },
        { key: 'Offline', slug: 'Offline' }
    ]

    const setSearch = async (data) => {
        if(data) {
            setValidationError(prevState => ({ ...prevState, searchByError: '' }));
            setSearchValues(prevState => ({ ...prevState, searchArrayData: '', searchKeyword: '', searchType: data}));
        }
    };

    const setSearchKey = (data) => {
        setSearchValues(prevState => ({ ...prevState, searchKeyword: data}));
    };

    const onSearch = async () => {
        let search = {};
        if (searchValues.searchKeyword?.length < 2) {
            setValidationError(prevState => ({ ...prevState, searchError: "Please enter at least 2 characters to execute a keyword search." }));
        } else if (!searchValues.searchType) {
            setValidationError(prevState => ({ ...prevState, searchByError: "Please select a 'Search By' option" }));
        } else {
            setValidationError(prevState => ({ ...prevState, searchError: "", searchByError: '' }));
            setContinuationToken(null);
            localStorage.removeItem(ORDER_PAGE_TOKEN);
    
            search = {
                [searchValues.searchType]: searchValues.searchKeyword
            };

            setSearchData(search);
    
            const keyToSearchType = {
                orderNumber: "Order Number",
                poNumber: "PO Number",
                invoiceNo: "Invoice Number",
                trackingNo: "Tracking/WayBill",
                releaseNo: "Release Number",
                orderType: "Order Type",
            };
    
            const filterList = Object.entries(search)
                .filter(([key, value]) => Helper.valueIsNotNull(value))
                .map(([key, value]) => ({
                    searchType: keyToSearchType[key],
                    key,
                    [Array.isArray(value) ? 'searchKeywordArr' : 'searchKeyword']: value,
                }));

            const filterListObject = filterList.reduce((acc, curr) => {
                acc[curr.key] = curr;
                return acc;
            }, {});
    
            const data = await updateFilterList(filter_list, filterListObject, keyToSearchType)
            set_filter_list(data);
        }
    };
    
    const updateFilterList = (prevFilterList, filterListObject, keyToSearchType) => {
        const existingFilters = prevFilterList || {};
    
        const updatedFilterList = Object.entries(existingFilters)
                .filter(([key]) => !keyToSearchType.hasOwnProperty(key))
                .reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {});
    
        return { ...updatedFilterList, ...filterListObject };
    };
    
    useEffect(() => {
        if (!filter_list || Object.keys(filter_list).length === 0) {
            setSearchValues(prevState => ({ ...prevState, searchArrayData: '', searchKeyword: '', searchType: ''}));
            setSearchData({})
        } else {
            const filterKeys = Object.keys(filter_list);
      
            const updatedSearchData = Object.keys(searchData).reduce((acc, key) => {
              if (filterKeys.includes(key)) {
                acc[key] = searchData[key];
              }
              return acc;
            }, {});
      
            setSearchData(updatedSearchData);
        }
        setSearchValues(prevState => ({ ...prevState, searchArrayData: filter_list?.Manufacturer?.searchKeywordArr}));
    }, [filter_list]);

    return (
        <>
            <div className="d-flex flex-wrap orderhistory-filter">
                <div className='m-b-10 m-r-15 '>
                    <label className="my-0 me-2" htmlFor="searchBy">Search by</label>
                    <Dropdown defaultText="-- Select --"
                        class={'test'}
                        id="ddlSearchBy"
                        onDdlCallback={setSearch}
                        ddlList={searchByDropdown}
                        label={"slug"}
                        value={"key"}
                        selectedValue={searchValues.searchType}
                    />
                    {validationError.searchByError.trim().length > 0 && <p className='error mb-0'>{validationError.searchByError}</p>}
                </div>
                {searchValues.searchType.toLocaleLowerCase() !== 'ordertype' &&
                    <div className="m-b-10 m-r-15 maxw240 minw240">
                        <label className="my-0 me-2"></label>
                        <input type="text" className='form-control form-control-sm' placeholder={searchOptionModified[searchValues.searchType] || 'Search By'} name={searchValues.searchType} value={searchValues.searchKeyword}
                            onChange={({ target: { value } }) => {setValidationError(prevState => ({ ...prevState, searchError: "" })); setSearchKey(value)}}
                        />
                        {validationError.searchError.trim().length > 0 && <p className='error mb-0'>{validationError.searchError}</p>}
                    </div>
                }

                {searchValues.searchType !== '' && searchValues.searchType.toLocaleLowerCase() === 'ordertype' &&
                    <div className="m-b-5 m-r-15 maxw240 minw240">
                         <label className="my-0 me-2"></label>
                        <Dropdown defaultText="Select Order Type"
                            class={'test'}
                            id="ddlOrderType"
                            onDdlCallback={setSearchKey}
                            ddlList={orderTypeList}
                            label={"slug"}
                            value={"key"}
                            selectedValue={searchValues.searchKeyword}
                        />
                    </div>
                }

                <div className='m-b-10 me-3 mt-3 pt-1'>
                    <button className={'bs5 btn btn-secondary w105 ' + ((searchValues.searchKeyword) || searchValues.searchArrayData?.length > 0 ? "" : "disabled")}
                        onClick={() => onSearch()}
                        disabled={!((searchValues.searchKeyword) || searchValues.searchArrayData?.length > 0)}>
                        Search
                    </button>
                </div>
                <div className="bs5 mt-3 pt-2">
                        <a href={void (0)} data-toggle="modal" data-target="#delete-quote-Modal"
                            onClick={(e) => {
                                e.preventDefault();
                                System.popup('OrderAdvanceFilterPopup')
                            }}><i className="fa fa-filter text-blue-stone me-1"></i>Advanced Filters</a>
                    </div>
            </div>
            <ObjCommonFilterSelection />
        </>
    )
}

export default OrderHistorySearchFilter